import { Input, Component, Optional, Inject, ChangeDetectorRef } from '@angular/core';
import { UtilityService } from '@app/core/services/utility.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { ProductGet, ProductService } from '@app/services/product.service';
import { StockService } from '@app/services/stock.service';

@Component({
    selector: 'tt-product-functions',
    templateUrl: './product-functions.component.html',
    styleUrls: ['./product-functions.component.css'],
})
export class ProductFunctionsComponent {
    @Input()
    public params?: ProductGet;

    public saving = false;

    public deleting = false;

    public gotoSearchStockLoading = false;

    constructor(
        private product: ProductService,
        private stock: StockService,
        private utility: UtilityService,
        private cdr: ChangeDetectorRef,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) private navigator?: TTViewNavigator,
    ) {}

    public async gotoSearchStock(event: MouseEvent) {
        if (!this.params) return;

        try {
            this.gotoSearchStockLoading = true;

            const { webpagename, parms } = await this.stock.scan({ barcode: this.params.prod_id, functionname: 'stock' });

            if (this.utility.isModifierKeyPressed(event)) {
                await this.navigator?.newTab({ to: webpagename, parms: parms });
            } else {
                await this.navigator?.go({ to: webpagename, parms: parms });
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.gotoSearchStockLoading = false;
        }
    }

    public async deleteProduct() {
        if (!this.params) return;

        try {
            this.deleting = true;
            this.cdr.markForCheck();

            const response: any = await this.product.deleteProduct(this.params);

            // RHE 20260908 - Returner bare dersom der ikke er en validerings melding fra databasen.
            if (!response?.validation) {
                this.navigator?.back();
            }
        } catch (error) {
            console.error(error);
        } finally {
            this.deleting = false;
            this.cdr.markForCheck();
        }
    }
}
